export default {
  isLoading: false,
  companyDetails: {},
  sucursalDetails: {},
};
